import { Alert, Spinner } from "react-bootstrap";
import { PrimaryButton } from "components/Button/style";
import { IPlacaImportacao } from "../types";

interface BadgePlacaProps {
  placa: string;
  bg: string;
  color: string;
  onRemover?: () => void;
}

function BadgePlaca({ placa, bg, color, onRemover }: BadgePlacaProps) {
  return (
    <span
      style={{
        background: bg, color,
        padding: "2px 10px", borderRadius: 20, fontSize: "0.85rem", fontWeight: 600,
        display: "inline-flex", alignItems: "center", gap: 6,
      }}
    >
      {placa}
      {onRemover && (
        <button
          onClick={onRemover}
          style={{
            background: "none", border: "none", cursor: "pointer", color,
            fontWeight: 700, fontSize: "0.85rem", padding: "0 2px", lineHeight: 1,
          }}
          title="Remover"
        >
          ×
        </button>
      )}
    </span>
  );
}

interface ResultadoImportacaoModalProps {
  resultado: IPlacaImportacao[];
  loading: boolean;
  onRemover: (placa: string) => void;
  onCancelar: () => void;
  onProsseguir: () => void;
}

export function ResultadoImportacaoModal({ resultado, loading, onRemover, onCancelar, onProsseguir }: ResultadoImportacaoModalProps) {
  const prontas = resultado.filter((r) => !r.erro && !r.jaComTag);
  const comTag = resultado.filter((r) => !r.erro && r.jaComTag);
  const duplicadas = resultado.filter((r) => r.duplicada);
  const erros = resultado.filter((r) => r.erro && !r.duplicada);
  const validasCount = resultado.filter((r) => !r.erro && r.idProcesso).length;

  return (
    <div
      style={{
        position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: "rgba(0,0,0,0.55)", zIndex: 10000,
        display: "flex", alignItems: "center", justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "#fff", borderRadius: 10, padding: 28,
          width: "100%", maxWidth: 560, maxHeight: "85vh",
          display: "flex", flexDirection: "column", gap: 16,
          boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
        }}
      >
        <h5 style={{ margin: 0, fontWeight: 700 }}>Resultado da Validação</h5>

        <div style={{ overflowY: "auto", flex: 1, display: "flex", flexDirection: "column", gap: 12 }}>
          {prontas.length > 0 && (
            <div>
              <p style={{ fontWeight: 600, color: "#198754", marginBottom: 8 }}>
                ✓ {prontas.length} placa(s) prontas para importar:
              </p>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                {prontas.map((r) => (
                  <BadgePlaca key={r.placa} placa={r.placa} bg="#d1e7dd" color="#0f5132" />
                ))}
              </div>
            </div>
          )}

          {comTag.length > 0 && (
            <div>
              <p style={{ fontWeight: 600, color: "#856404", marginBottom: 8 }}>
                ⚠ {comTag.length} placa(s) já possuem tag vinculada em outro lote:
              </p>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                {comTag.map((r) => (
                  <BadgePlaca key={r.placa} placa={r.placa} bg="#fff3cd" color="#664d03" onRemover={() => onRemover(r.placa)} />
                ))}
              </div>
            </div>
          )}

          {duplicadas.length > 0 && (
            <div>
              <p style={{ fontWeight: 600, color: "#6c757d", marginBottom: 8 }}>
                ⊘ {duplicadas.length} placa(s) repetida(s) na planilha (não serão processadas):
              </p>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                {duplicadas.map((r) => (
                  <BadgePlaca key={r.placa} placa={r.placa} bg="#e2e3e5" color="#41464b" />
                ))}
              </div>
            </div>
          )}

          {erros.length > 0 && (
            <div>
              <p style={{ fontWeight: 600, color: "#dc3545", marginBottom: 8 }}>
                ✗ {erros.length} placa(s) sem processo no sistema:
              </p>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                {erros.map((r) => (
                  <BadgePlaca key={r.placa} placa={r.placa} bg="#f8d7da" color="#842029" onRemover={() => onRemover(r.placa)} />
                ))}
              </div>
            </div>
          )}

          {resultado.length === 0 && (
            <Alert variant="warning">Nenhuma placa restante para importar.</Alert>
          )}
        </div>

        <div className="d-flex justify-content-end gap-2 pt-2" style={{ borderTop: "1px solid #dee2e6" }}>
          <PrimaryButton outline variante="primary" onClick={onCancelar} disabled={loading}>
            Cancelar
          </PrimaryButton>
          <PrimaryButton onClick={onProsseguir} disabled={loading || validasCount === 0}>
            {loading ? <Spinner animation="border" size="sm" /> : `Prosseguir (${validasCount} placas)`}
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
}
